import React from 'react';

function Footer() {
  return (
    <footer className="tc-footer-style1 border-top">
      <div className="container">
        <div className="top-content section-padding">
          <div className="row gx-0">
            <div className="col-lg-4">
              <div className="info-side">
                 <div className="footer-logo mb-20">
                  <img
                    src="/innerpages/assets/img/logos/DB-Circle-Logo.png"
                    alt="DB Architekt Logo"
                    style={{ maxWidth: "180px", height: "auto" }}
                  />
                </div>
                <div className="text fsz-20 color-333 lh-3 fw-600 footer-description">
                  We believe that architecture has the power to shape lives and uplift communities. DB Architekt&lsquo;s philosophy is passion for innovation, sustainablity and timeless aesthetics
                </div>
                {/* <div className="foot-social mt-50">
                  <a href="https://www.facebook.com/dbarchitekt/">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://www.instagram.com/db.architekt/">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="https://in.linkedin.com/company/dbarchitekt">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="https://www.youtube.com/channel/UC2Vxn_hmgyO_tloro3RH-8Q">
                    <i className="fab fa-youtube"></i>
                  </a>
                </div> */}
              </div>
            </div>
            <div className="col-lg-3 ">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 mt-lg-0 fw-600">  Work </h5>
                <ul className="footer-links">
                  <li>
                    <a href="/innerpages/contact">Contect From</a>  
                  </li>
                  <li>
                    <a href="/innerpages/contact">Vender Registation From</a>
                  </li>
                  <li>
                    <a href="/innerpages/contact">Job & Internship Apply</a>
                  </li>
                </ul>
                <div className="foot-social mt-50">
                  <a href="https://www.facebook.com/dbarchitekt/" target="_blank">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://www.instagram.com/db.architekt/" target="_blank">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="https://in.linkedin.com/company/dbarchitekt" target="_blank">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="https://www.youtube.com/channel/UC2Vxn_hmgyO_tloro3RH-8Q" target="_blank">
                    <i className="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
              {/* <div className="branch-card">
                <h5 className="mb-20 mt-5 fw-600"> Work</h5>
                <ul className="footer-links">
                  <li>
                    <a href="#"> 3D Visualization Architect </a>
                  </li>
                  <li>
                    <a href="#"> Interior Architect </a>
                  </li>
                  <li>
                    <a href="#"> Sustainable Design Architect </a>
                  </li>
                </ul>
              </div> */}
            </div>
            <div className="col-lg-3">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 mt-lg-0 fw-600">  Our Address </h5>
                <ul className="footer-links">
                  <li>
                    <a href="#"> D9, Ground Floor
                      Sector-3,
                      Noida-201301 <br />
                      Uttar Pradesh-India</a>
                  </li>
                  <li>
                    <a href="mailto:db@dbarchitekt.com"> db@dbarchitekt.com </a>
                  </li>
                  <li>
                    <a href="tel:+919953930100"> +91 99539 30100 </a>
                  </li>
                </ul>
              </div>
              {/* <div className="branch-card">
                <h5 className="mb-20 mt-5 fw-600"> Helps </h5>
                <ul className="footer-links">
                  <li>
                    <a href="#"> Term & Conditions </a>
                  </li>
                  <li>
                    <a href="#"> Partner Policy </a>
                  </li>
                </ul>
              </div> */}
            </div>
              <div className="col-lg-2 ">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 mt-lg-0 fw-600">Europe Office</h5>
                <ul className="footer-links">
                  <li>  <a href="#">
    Mainski Put – Mega Ulaz II/1 <br />
    Budva 85310, Montenegro
  </a></li>
   <li>
                    <a href="mailto:db@dbarchitekt.com"> db@dbarchitekt.com </a>
                  </li>
                  <li>
                    <a href="tel:+919953930100"> +91 99539 30100 </a>
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </div>
        <div className="foot">
          <div className="row">
            <div className="col-lg-6">
              <p className="fsz-13">© 2026 DB Architekt. All Right Reserved</p>
            </div>
            <div className="col-lg-6">
              <div className="foot-links mt-4 mt-lg-0">
                <a href="/"> Home </a>
                <a href="/innerpages/about"> About </a>
                <a href="/innerpages/portfolio">Projects </a>
                <a href="/innerpages/blog"> Blog </a>
                <a href="/innerpages/services"> Service</a>
                <a href="/innerpages/Sector"> Sector</a>
                <a href="/innerpages/contact"> Contact </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
